import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useAppStore } from '@/stores/app.store';

import { Loader } from '@progress/kendo-vue-indicators';
import { Dialog as kDialog } from '@progress/kendo-vue-dialogs';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderHotReloading',
  setup(__props) {

const appStore = useAppStore();

if (
  process.env.NODE_ENV === 'development' &&
  process.env.VUE_APP_WEBPACK_MORE_BUILD_INFO === 'true'
) {
  console.info('Enable more info mode...');
  if (module.hot) {
    module.hot.accept();
  }

  window.onmessage = function (event) {
    if (event?.type == 'message' && event?.data?.type === 'webpackOk') {
      appStore.isAppHotReloading = false;
    }

    if (event?.type == 'message' && event?.data?.type === 'webpackInvalid') {
      appStore.isAppHotReloading = true;
    }
  };
}

return (_ctx: any,_cache: any) => {
  return (_unref(appStore).isAppHotReloading)
    ? (_openBlock(), _createBlock(_unref(kDialog), {
        key: 0,
        width: '100%',
        modal: true,
        class: "hot-reloading-dialog"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(Loader), {
              size: "large",
              type: "infinite-spinner"
            }),
            _cache[0] || (_cache[0] = _createElementVNode("h2", null, "webpack is working...", -1))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})